import request from '@/utils/request'

export function getTranslations(code='en') {
    // Beware: used in json export
    return request({
        url: '/translations/' + code,
        method: 'get'
    })
}

export function getLanguages() {
    return request({
        url: '/admin/language',
        method: 'get'
    })
}

export function getAdminTranslations(code) {
    return request({
        url: '/admin/language/'+code+'/translation',
        method: 'get'
    })
}

export function updateAdminTranslations(code, data) {
    return request({
        url: '/admin/language/'+code+'/translation',
        method: 'post',
        data: data
    })
}

export function createLanguage(payload) {
    return request({
        url: '/admin/language',
        method: 'post',
        data: payload
    })
}

export function importTranslations(code, data) {
    return request({
        url: '/admin/language/'+code+'/translation/import',
        method: 'post',
        data: data,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}